<template>
  <div
    class="empty-state tw-flex tw-flex-1"
  >
    <div class="tw-flex tw-flex-col tw-items-center tw-text-center tw-m-auto tw-w-full">
      <img
        src="@/assets/img/icons/rejected.svg"
        alt=""
        width="80"
        height="80"
        class="tw-mb-4"
        data-test="icon"
      >
      <h3
        v-text="title"
        class="tw-text-xl tw-font-normal tw-mx-auto tw-mb-6 md:tw-w-2/3"
        data-test="title"
      />

      <slot />
    </div>
  </div>
</template>

<script>
  import { defineComponent } from '@vue/composition-api'

  export default defineComponent({
    name: 'EmptyState',
    props: {
      title: {
        type: String,
        required: true
      },
      iconPath: {
        type: String,
        default: '@/assets/img/icons/rejected.svg'
      }
    }
  })
</script>
